


































import { Component, Vue } from 'vue-property-decorator';
import Modal from '@/main-components/common/modal/Modal.vue';
import MainButton from '../MainButton.vue';
import { createLifeTimeSubscription } from '@/utils/subscription/subscription.util';
@Component({
  components: {
    Modal,
    MainButton,
  },
})
export default class ModalStudyGroup extends Vue {
  openModal: any = null;
  closeModal: any = null;

  mounted() {
    this.$emit('ModalStudyGroupAdd', this.openModal);
  }

  openModalAdd(openModal: any) {
    this.openModal = openModal;
  }

  closeModalAdd(closeModal: any) {
    this.closeModal = closeModal;
  }

  async onJoinClick() {
    this.$sendMpEvent({
      event: this.$mp_value.LifeTimeClick,
    });

    this.$toasted.global.mainToast({
      message: 'Redirect to Payment...',
    });

    const checkoutUrl = await createLifeTimeSubscription();
    if (checkoutUrl) {
      window.open(checkoutUrl, '_self');
    }
  }
}
